<template>
  <v-container fluid>
    <HeaderLabel class="mb-2" title=" Profile Details" />

    <v-container fluid class="custom-container-box">
      <div class="d-flex justify-end mb-4" v-if="masterUserId">
        <v-btn depressed @click="goToChangeMasterUserNamePage">Change User Name</v-btn>
      </div>
      <ProfileEditForm
        v-if="model._id"
        :profile="model"
        :id="id"
        :isSubmitting="false"
        @reload="reload"
        @update="handleUpdate"
      />
    </v-container>
  </v-container>
</template>

<script>
import ProfileEditForm from '@/components/Identity/ProfileEditForm.vue';
import { readProfile, getUserListByProfileId, patchProfile } from '@/api/auth/membership';
import api from '@/api';
import { mapGetters, mapActions } from 'vuex';
import { relatedAccountsPopulate } from '@/api/auth/membership';
import HeaderLabel from '@/components/customFormLabel/headerLabel.vue';

export default {
  name: 'identityDetails',
  components: {
    ProfileEditForm,
    HeaderLabel,
  },
  props: {
    id: {},
  },
  data() {
    return {
      model: {},
      masterUserId: null,
    };
  },
  watch: {
    id: {
      immediate: true,
      handler(v) {
        if (v) {
          this.reload();
        }
      },
    },
  },
  computed: {
    ...mapGetters('auth', ['isAdmin']),
  },
  methods: {
    ...mapActions('alert', ['updateAlertMessage']),
    async reload() {
      this.model = await readProfile(api, this.id, {
        populate: [
          { path: 'user' },
          relatedAccountsPopulate,
          { path: 'updated_by', select: { name: 1 } },
          { path: 'medicalHistory.updated_by', select: { name: 1 } },
        ],
      });
      if (this.isAdmin) {
        this.masterUserId = await getUserListByProfileId(api, this.id);
      }
    },
    async handleUpdate(payload) {
      try {
        await patchProfile(api, this.id, payload);
        await this.updateAlertMessage({
          msg: 'Profile updated successfully',
          type: 'success',
          color: 'success',
        });
        await this.reload();
      } catch (error) {
        console.error('Error updating profile:', error);
        await this.updateAlertMessage({
          msg: 'Failed to update profile',
          type: 'error',
          color: 'error',
        });
      }
    },
    async goToChangeMasterUserNamePage() {
      if (!this.masterUserId) return alert('cannot get user Id');
      this.$router.push({
        name: 'changeMasterUserName',
        params: { id: this.masterUserId.docs?.[0]?._id },
      });
    },
  },
};
</script>

<style scoped lang="scss"></style>
